import { TEAM_MEMBER_APIS } from "libs/apis/team-members.api";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";

const useTeamMembers = () => {
  const navigate = useNavigate();

  const uploadFile = async (params: FormData): Promise<string | null> => {
    try {
      const response = await TEAM_MEMBER_APIS.uploadFile(params);
      const { status = false, message = "", data = null } = response || {};

      if (status && data) {
        return data;
      }

      return null;
    } catch (error) {
      console.error("Upload failed", error);
      return null;
    }
  };


  const getTeamMembers = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await TEAM_MEMBER_APIS.getTeamMembers(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      setFilters((prev) => ({
        ...prev,
        page: pageNumber + 1,
        limit: pageSize,
      }));
      setTotalElements?.(totalElements);
    }
  };

  const addCreateTeamMember = async (body: any) => {
    const response = await TEAM_MEMBER_APIS.addCreateTeamMember(body);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const getTeamMemberByID = async (id: number, setUser: Function) => {
    const response = await TEAM_MEMBER_APIS.getTeamMemberByID(id);
    const { status = false, data = {} } = response || {};
    if (status) {
      setUser(data);
    }
  };

  const editTeamMember = async (id: number, queryParams: any = {}) => {
    const response = await TEAM_MEMBER_APIS.editTeamMember(id, queryParams);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };



  const addAvailableSlots = async (body: any, queryParams: any = {}) => {
    const response = await TEAM_MEMBER_APIS.addAvailableSlots(body, queryParams);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const getAvailableSlotsByID = async (
    setData: Function,
    queryParams: any = {}
  ) => {
    const response = await TEAM_MEMBER_APIS.getAvailableSlotsByID(queryParams);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data);
    }
  };

  const getAllRolePermissions = async (
    setData: Function,

  ) => {
    const response = await TEAM_MEMBER_APIS.getAllRolePermissions();
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = []
      } = data;
      setData(content);
    }
  };

  const addRolePermission = async (body: any) => {
    const response = await TEAM_MEMBER_APIS.addRolePermission(body);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const getRoles = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await TEAM_MEMBER_APIS.getRoles(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;

      setData(content);
      setFilters((prev) => ({
        ...prev,
        page: pageNumber + 1,
        limit: pageSize,
      }));
      setTotalElements?.(totalElements);
    }
  };

  const toggleRole = async (userId: number) => {
    const response = await TEAM_MEMBER_APIS.toggleRole(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster("Status updated successfully");
    }
  };

  const activateMember = async (userId: number) => {
    const response = await TEAM_MEMBER_APIS.activateMember(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const deactivateMember = async (userId: number) => {
    const response = await TEAM_MEMBER_APIS.deactivateMember(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const getRolesInTeam = async (
    setRoles: Function,
    queryParams: any = {},
  ) => {
    const response = await TEAM_MEMBER_APIS.getRoles(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
      } = data;

      setRoles(content);
    }
  };

  //   const getRoleByID = async (id: number, setData: Function) => {
  //   const response = await TEAM_MEMBER_APIS.getRoleByID(id);
  //   const { status = false, data = {} } = response || {};
  //   if (status) {
  //     setData(data);
  //   }
  // };


  const getRoleByID = async (
    setDataByID: Function,
    queryParams: any = {},
  ) => {
    const response = await TEAM_MEMBER_APIS.getRoleByID(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
      } = data;

      setDataByID(content);

    }
  };


  const editRole = async (id: number, body: any = {}) => {
    const response = await TEAM_MEMBER_APIS.editRole(id, body);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  return {
    uploadFile,
    getTeamMembers,
    addCreateTeamMember,
    getTeamMemberByID,
    editTeamMember,
    addAvailableSlots,
    getAvailableSlotsByID,
    getAllRolePermissions,
    addRolePermission,
    getRoles,
    getRolesInTeam,
    toggleRole,
    editRole,
    getRoleByID,
    activateMember,
    deactivateMember,
  };
};

export default useTeamMembers;
